import type {
  ConcentricLayoutConfig,
  ForceAtlas2LayoutConfig,
  ForceLayoutConfig,
  GForceLayoutConfig,
} from '../types'

export const DEFAULT_LAYOUT_OPTIONS: {
  force: Partial<ForceLayoutConfig>
  gForce: Partial<GForceLayoutConfig>
  concentric: Partial<ConcentricLayoutConfig>
  forceAtlas2: Partial<ForceAtlas2LayoutConfig>
} = {
  force: {
    preventOverlap: true,
    linkDistance: 140,
    alpha: 1,
    alphaMin: 0.1,
    alphaDecay: 0.0228,
    nodeStrength: -800,
    nodeSpacing: 0,
  },
  gForce: {
    linkDistance: () => 200,
    preventOverlap: true,
  },
  concentric: {
    minNodeSpacing: 60,
    preventOverlap: true,
  },
  forceAtlas2: {
    kr: 10,
    preventOverlap: true,
  },
}
